import React, { useState } from 'react';
import { firestore, storage } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const AdminPage = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      if (!image) {
        throw new Error('Please upload an image.');
      }

      const imageRef = ref(storage, `news/${image.name}`);
      await uploadBytes(imageRef, image);
      const imageUrl = await getDownloadURL(imageRef);

      await addDoc(collection(firestore, 'news'), {
        title,
        content,
        imageUrl,
        createdAt: new Date(),
      });

      setTitle('');
      setContent('');
      setImage(null);
      setSuccess('News article posted successfully!');
    } catch (err) {
      setError(err.message);
    }
  };

  return (<>
    <div>
      <h1>Admin Page</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>{success}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title"
        />
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Content"
        />
        <input
          type="file"
          onChange={(e) => setImage(e.target.files[0])}
          placeholder="Upload Image"
        />
        <button type="submit">Post News</button>
      </form>
    </div></>
  );
};

export default AdminPage;
